import SmoothScroll from 'smooth-scroll';
import MicroModal from 'micromodal';
import Splide from '@splidejs/splide';
// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// MARK:初期変数
const $html = document.querySelector('html');
const $body = document.querySelector('body');
const $header = document.querySelector('.header');
const $footer = document.querySelector('.footer');
const $cssRoot = getComputedStyle(document.querySelector(':root'));

const bkp = $cssRoot.getPropertyValue('--breakpoint');

// breakpoint
const mediaQuery = window.matchMedia('(min-width:' + bkp + ')');


// 共通 Option値
const defaultOption = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01
};

// オプション生成用のユーティリティ関数
const createObserverOptions = (customOptions = {}) => ({
  ...defaultOption, // デフォルトオプションを展開
  ...customOptions // カスタムオプションを展開
});

// IntersectionObserverのオプション設定
const observerOptions = {

  // 標準
  standard: createObserverOptions({
    rootMargin: '0px 0px -15%'
  }),

  // header
  header: createObserverOptions({
    rootMargin: '-25% 0px 0px'
  }),

  // fv
  fv: createObserverOptions({
    rootMargin: '0px 0px 0px',
  }),

  // anchornav
  anchornav: createObserverOptions({
    rootMargin: '-45% 0px -50%',
  }),

  // footer
  footer: createObserverOptions({
    rootMargin: '0px 0px 0px'
  }),

  // 拡張用（設定したオプション以外を拡張できるよう用意）
  extension: createObserverOptions(),
};

function responsivecheck(e) {
  if (e.matches) {
    return 'pc';
  } else {
    return 'sp';
  }
}

// MARK:トップページ オープニングとギャラリー
const $loading = 'is-loaded';
const $loadend = 'is-loadend';

// DOM生成後処理開始・setTimeoutの数値でロード完了後の起動を調整する
document.addEventListener('DOMContentLoaded', () => {
  if (!$body.classList.contains('home')) return;
  setTimeout(function () {
    $body.classList.add($loading);

    const $lastAnime = document.querySelector('.home__event');
    $lastAnime.addEventListener('transitionend', (e) => {
      // トランジション終了後、アニメーションストップ
      $body.classList.add($loadend);

      setTimeout(function () {
        // ギャラリーのアニメーション開始
        document.querySelector('.home__kv--bg').classList.add('is-imgplay');
      }, 500);
    });

  }, 500);
});


// DOM生成後に実行
document.addEventListener('DOMContentLoaded', () => {

  // MARK:Viewport変更
  // [note] タブレット端末でのみPC最小幅に設定

  // タブレット端末かどうかを判定
  const ua = navigator.userAgent;

  // iPad判定
  const isIPad = ua.indexOf('iPad') > -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document);

  // Androidタブレット判定
  // Androidを含むが、Mobileを含まない場合はタブレット
  const isAndroidTablet = ua.indexOf('Android') > -1 &&
    ua.indexOf('Mobile') === -1;

  // タブレット判定（isIPadとisAndroidTabletがtrue）
  const isTablet = isIPad || isAndroidTablet;
  setViewport(isTablet);

  // Viewport設定を行う関数
  function setViewport(isTablet) {
    // Viewportの処理を実行
    if (isTablet) {

      // htmlタグにclassを追加
      $html.classList.add('is-tablet');

      // 設定するデザイン幅
      const designWidth = 1280;

      // デバイスの幅を取得してスケールを計算（デバイス幅 ÷ デザイン幅）
      const deviceWidth = window.screen.width;
      const scale = deviceWidth / designWidth;

      // 既存のviewportタグを取得して内容を設定
      let viewport = document.querySelector('meta[name="viewport"]');
      viewport.content = `width=${designWidth}, initial-scale=${scale}, minimum-scale=${scale}, maximum-scale=${scale}`;

      // 画面の向きが変わったときに実行
      // window.addEventListener('orientationchange', function () {
      //   location.reload();
      // });

    } else {

      $html.classList.remove('is-tablet');

    }
  }


  /*
   * MARK:スムーススクロール（プラグイン使用）
    https://github.com/cferdinandi/smooth-scroll
   ------------------------------------ */

  //  初期化
  let scroll;
  let scrollOps = {
    speed: 400,
    easing: 'easeOutCubic',
    updateURL: false,
    speedAsDuration: true,
    offset: function () {
      //CSS変数から高さを取得
      return parseInt($cssRoot.getPropertyValue('--header-height'));
    }
  };

  const initScroll = () => {
    scroll = new SmoothScroll('a[href*="#"], svg a[href*="#"]', scrollOps);
  };
  // 実行
  initScroll();

  // ブレイクポイント変更時、高さを再設定
  const funcScrollOpt = (e) => {

    // 既存のインスタンスを破棄
    scroll.destroy();

    // 新しいインスタンスを生成
    initScroll();
  };

  // 初期実行とmatchMediaの変更を監視
  mediaQuery.addEventListener("change", funcScrollOpt);
  funcScrollOpt(mediaQuery);

  // SVG内のアンカーリンクに対する処理を追加
  const svgLinks = document.querySelectorAll('svg a[href*="#"]');

  svgLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      // href または xlink:href の値を取得
      const href = this.getAttribute('href');

      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // スムーススクロールプラグインの animateScroll メソッドを使用
          const headerHeight = parseInt($cssRoot.getPropertyValue('--header-height'));
          scroll.animateScroll(targetElement, null, {
            offset: headerHeight
          });
        }
      }
    });
  });


  // MARK:ハンバーガーメニュー
  const $spTrigger = document.querySelector('[data-spnavtrigger]');
  const $spNav = document.querySelectorAll('#' + $spTrigger.getAttribute('aria-controls') + ' ' + 'a');
  const $gnav = document.getElementById($spTrigger.getAttribute('aria-controls'));
  const $openClass = 'is-gnav';

  // メニューを閉じる関数
  const closeMenu = () => {
    $spTrigger.setAttribute('aria-expanded', 'false');
    $spTrigger.setAttribute('aria-label', 'Navigation Open');
    $gnav.setAttribute('aria-hidden', 'true');
    $html.classList.remove($openClass);
    $spNav.forEach(link => { link.tabIndex = -1; });
  };

  // ナビゲーションの処理
  // tabindexの設定とアンカーリンクの処理（ナビゲーションを閉じる）
  $spNav.forEach(link => {
    link.addEventListener('click', function (e) {
      $spTrigger.setAttribute('aria-expanded', 'false');
      $spTrigger.setAttribute('aria-label', 'Navigation Open');
      document.querySelector('#' + $spTrigger.getAttribute('aria-controls')).setAttribute('aria-hidden', 'true');
      $html.classList.remove($openClass);
      closeMenu();
    });
  });

  // ハンバーガーボタンの処理
  $spTrigger.addEventListener('click', function (e) {
    let $getTgt = e.target.getAttribute('aria-controls');
    let $getLabel = e.target.querySelector('.is-label');
    let $tgt = document.getElementById($getTgt);

    if (e.target.getAttribute('aria-expanded') == 'false') {
      // 初期値 = false
      e.target.setAttribute('aria-expanded', 'true');
      e.target.setAttribute('aria-label', 'Navigation Close');
      $tgt.setAttribute('aria-hidden', 'false');
      $getLabel.textContent = '閉じる';

      $spNav.forEach(link => {
        link.tabIndex = 0;
      });

    } else {
      e.target.setAttribute('aria-expanded', 'false');
      e.target.setAttribute('aria-label', 'Navigation Open');
      $tgt.setAttribute('aria-hidden', 'true');
      $getLabel.textContent = 'メニュー';

      $spNav.forEach(link => {
        link.tabIndex = -1;
      });
    }

    $html.classList.toggle($openClass);
  });


  // レスポンシブ対応
  function spMenu(e) {
    if (e.matches) {

      // PC
      $html.classList.remove('is-gnav');
      $spTrigger.setAttribute('aria-expanded', 'true');
      $spTrigger.setAttribute('aria-label', 'Navigation Open');
      document.querySelector('#' + $spTrigger.getAttribute('aria-controls')).setAttribute('aria-hidden', 'false');

      $spNav.forEach(link => {
        link.tabIndex = 0;
      });

    } else {

      // SP
      $spTrigger.setAttribute('aria-expanded', 'false');
      $spTrigger.setAttribute('aria-label', 'Navigation Open');
      document.querySelector('#' + $spTrigger.getAttribute('aria-controls')).setAttribute('aria-hidden', 'true');

      $spNav.forEach(link => {
        link.tabIndex = -1;
      });

    }
  }

  // 初期化とmatchMediaの変更を監視
  mediaQuery.addEventListener('change', spMenu);
  spMenu(mediaQuery);


  /*
   * MARK:IntersectionObserver
   ------------------------------------ */

  // トップページのHeader背景を設定
  if ($body.classList.contains('home')) {

    const $homeKV = document.querySelector('.home__kv');
    const observer_header = new IntersectionObserver(scrHeaderEffect, observerOptions.header);
    observer_header.observe($homeKV);

    function scrHeaderEffect(entries) {
      const entriesArray = Array.prototype.slice.call(entries, 0);
      entriesArray.forEach(function (entry) {
        if (!entry.isIntersecting) {
          $header.classList.add('is-scroll');
          $pageTop.classList.remove('is-hide');
        } else {
          $header.classList.remove('is-scroll');
          $pageTop.classList.add('is-hide');
        }
      });
    }

  }

  // Page top ボタン
  const $pageTop = document.querySelector('.pagetop');

  if ($pageTop && !$body.classList.contains('home')) {

    // ページ上部で非表示
    const $showTgt = document.querySelector('[data-pagetopshow]');
    if ($showTgt) {
      const observer_pagetop1 = new IntersectionObserver(scrPageTopEffect1, observerOptions.fv);
      observer_pagetop1.observe($showTgt);
    }

    function scrPageTopEffect1(entries) {
      const entriesArray = Array.prototype.slice.call(entries, 0);
      entriesArray.forEach(function (entry) {
        if (!entry.isIntersecting) {
          $pageTop.classList.remove('is-hide');
        } else {
          $pageTop.classList.add('is-hide');
        }
      });
    }
  }


  if ($pageTop) {

    // フッター付近で画面固定を解除
    const observer_pagetop2 = new IntersectionObserver(scrPageTopEffect2, observerOptions.footer);
    observer_pagetop2.observe($footer);

    function scrPageTopEffect2(entries) {
      const entriesArray = Array.prototype.slice.call(entries, 0);
      entriesArray.forEach(function (entry) {
        if (!entry.isIntersecting) {
          $pageTop.classList.remove('is-static');
        } else {
          $pageTop.classList.add('is-static');
        }
      });
    }

  }

  // スクロール連動のアニメーション発火用
  const $view_inview = document.querySelectorAll('[data-inview]');
  const view_inviewArray = Array.prototype.slice.call($view_inview, 0);
  const $ac = 'is-show';

  const scrEffect = (entries) => {
    const entriesArray = Array.prototype.slice.call(entries, 0);
    entriesArray.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add($ac);
      }
    });
  }

  if ($view_inview.length) {
    const observer_inview = new IntersectionObserver(scrEffect, observerOptions.standard);
    view_inviewArray.forEach(function (view) {
      observer_inview.observe(view);
    });
  }


  // アンカーナビ（カレント更新）
  const $anchorSection = document.querySelectorAll('[data-anchorsection]');
  const $anchorSectionArray = Array.prototype.slice.call($anchorSection, 0);

  const scrAnchorCurrentUpdate = (entries) => {
    const entriesArray = Array.prototype.slice.call(entries, 0);
    entriesArray.forEach(function (entry) {
      if (entry.isIntersecting) {

        const $navLinkAll = document.querySelectorAll('.anchornav__link');
        const $currentLink = document.querySelector('[href*=' + entry.target.id + ']');
        const $navTrigger = document.querySelector('.anchornav__sptrigger');
        let $getLabel = $navTrigger.querySelector('.is-currentlabel');

        for (let i = 0; i < $navLinkAll.length; i++) {
          $navLinkAll[i].setAttribute('aria-selected', 'false');
        }

        // ボタンラベルを変更してカレントを更新する
        if ($currentLink) {
          $currentLink.setAttribute('aria-selected', 'true');
          $getLabel.textContent = $currentLink.textContent;
        }

      }
    });
  }


  if ($anchorSection.length) {
    const observer_anchorSection = new IntersectionObserver(scrAnchorCurrentUpdate, observerOptions.anchornav);
    $anchorSectionArray.forEach(function (view) {
      observer_anchorSection.observe(view);
    });
  }


  // アンカーナビ（ボタン処理）
  const $anchornav = document.querySelector('.anchornav');

  if ($anchornav) {
    const $anchorNavTrigger = document.querySelector('.anchornav__sptrigger');
    let $getLabel = $anchorNavTrigger.querySelector('.is-currentlabel');
    let $navtgt = document.getElementById($anchorNavTrigger.getAttribute('aria-controls'));

    const $anchorNavLink = document.querySelectorAll('.anchornav__link');

    $anchorNavTrigger.addEventListener('click', function (e) {

      // メニューを開閉する
      if (e.target.getAttribute('aria-expanded') == 'false') {
        // 初期値 = false
        e.target.setAttribute('aria-expanded', 'true');
        $navtgt.setAttribute('aria-hidden', 'false');

      } else {

        e.target.setAttribute('aria-expanded', 'false');
        $navtgt.setAttribute('aria-hidden', 'true');

      }
    });

    $anchorNavLink.forEach(link => {
      link.addEventListener('click', function (e) {

        for (let i = 0; i < $anchorNavLink.length; i++) {
          $anchorNavLink[i].setAttribute('aria-selected', 'false');
        }

        // ボタンラベルを変更してカレントを更新する
        $getLabel.textContent = e.target.textContent;
        e.target.setAttribute('aria-selected', 'true');

        if (responsivecheck(mediaQuery) == 'sp') {
          $anchorNavTrigger.setAttribute('aria-expanded', 'false');
          $navtgt.setAttribute('aria-hidden', 'true');
        }

      });
    });

    // レスポンシブ対応（メニューの表示／非表示切り替え）
    function funcAnchorNav(e) {
      if (e.matches) {

        // PC
        const $localnav = document.querySelector('#localnav');
        $localnav.setAttribute('aria-hidden', 'false');

      } else {

        // SP
        const $localnav = document.querySelector('#localnav');
        $localnav.setAttribute('aria-hidden', 'true');

      }
    }

    // 初期実行とmatchMediaの変更を監視
    mediaQuery.addEventListener("change", funcAnchorNav);
    funcAnchorNav(mediaQuery);

    // 画面スクロールでメニューを閉じる処理
    window.addEventListener('scroll', function () {
      // メニューが開いているか（aria-expanded="true"）を確認
      if ($anchorNavTrigger.getAttribute('aria-expanded') === 'true') {

        $anchorNavTrigger.setAttribute('aria-expanded', 'false');
        $navtgt.setAttribute('aria-hidden', 'true');

      }
    });

  }



  /*
   * MARK:アコーディオン処理 details & summary
   ------------------------------------ */

  /**
  * アニメーションの時間とイージング
  */
  const isRunning = 'running'; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const animTiming = {
    duration: 400,
    easing: 'cubic-bezier(0, 0, 0, 1)'
    // easing: 'ease-out'
  };

  /**
   * アコーディオンを閉じるときのキーフレーム
   */
  const closingAnimKeyframes = (content, height) => [
    {
      height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
      opacity: 1,
    }, {
      height: height,
      opacity: 0,
    }
  ];

  /**
   * アコーディオンを開くときのキーフレーム
   */
  const openingAnimKeyframes = (content, height) => [
    {
      height: height,
      opacity: 0,
    }, {
      height: content.offsetHeight + 'px',
      opacity: 1,
    }
  ];


  const $accdDetails = document.querySelectorAll('[data-details]');

  if ($accdDetails.length) {

    $accdDetails.forEach((element) => {
      const summary = element.querySelector('[data-summary]');
      const content = element.querySelector('[data-desc]');

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        let closeHeight = 0;

        // 連打防止
        if (element.dataset.animStatus === isRunning) {
          return;
        }

        if (element.open) {
          // アコーディオンを閉じるときの処理
          // element.classList.toggle(accordionClass);

          const closingAnim = content.animate(closingAnimKeyframes(content, closeHeight), animTiming);
          element.dataset.animStatus = isRunning;

          setTimeout(function () {
            element.removeAttribute('open');
          }, 50);

          closingAnim.onfinish = () => {
            element.dataset.animStatus = '';
          };

        } else {
          // アコーディオンを開くときの処理
          element.setAttribute('open', 'true');
          // element.classList.toggle(accordionClass);

          const openingAnim = content.animate(openingAnimKeyframes(content, closeHeight), animTiming);
          element.dataset.animStatus = isRunning;

          openingAnim.onfinish = () => {
            element.dataset.animStatus = '';
          };
        }
      });
    });

  }


  /*
   * MARK:アコーディオン処理（支部）
   ------------------------------------ */

  const $chaptersTrigger = document.querySelectorAll('[data-chapterstrigger]');

  if ($chaptersTrigger.length) {

    $chaptersTrigger.forEach((element) => {

      element.addEventListener('click', (e) => {
        e.preventDefault();
        const content = element.closest('.chapters__block--tbody').querySelector('.chapters__block--contents');

        let closeHeight = 0;

        // 連打防止
        if (element.dataset.animStatus === isRunning) {
          return;
        }

        if (element.classList.contains('is-open')) {
          // アコーディオンを閉じるときの処理
          // element.classList.toggle(accordionClass);

          if (responsivecheck(mediaQuery) == 'sp') {
            const closingAnim = content.animate(closingAnimKeyframes(content, closeHeight), animTiming);
            element.dataset.animStatus = isRunning;

            setTimeout(function () {
              element.classList.remove('is-open');
              content.setAttribute('aria-hidden', 'true');
            }, 50);

            closingAnim.onfinish = () => {
              element.dataset.animStatus = '';
            };
          }

        } else {
          // アコーディオンを開くときの処理
          if (responsivecheck(mediaQuery) == 'sp') {
            element.classList.add('is-open');
            content.setAttribute('aria-hidden', 'false');

            const openingAnim = content.animate(openingAnimKeyframes(content, closeHeight), animTiming);
            element.dataset.animStatus = isRunning;

            openingAnim.onfinish = () => {
              element.dataset.animStatus = '';
            };
          }
        }
      });
    });

    // レスポンシブ対応（メニューの表示／非表示切り替え）
    function funcChapters(e) {
      if (e.matches) {

        // PC
        const $chaptersConts = document.querySelectorAll('.chapters__block--contents');
        for (let i = 0; i < $chaptersConts.length; i++) {
          $chaptersConts[i].setAttribute('aria-hidden', 'false');
        }

      } else {

        // SP
        const $chaptersConts = document.querySelectorAll('.chapters__block--contents');
        for (let i = 0; i < $chaptersConts.length; i++) {
          $chaptersConts[i].setAttribute('aria-hidden', 'true');
        }

      }
    }

    // 初期実行とmatchMediaの変更を監視
    mediaQuery.addEventListener("change", funcChapters);
    funcChapters(mediaQuery);
  }


  /*
   * MARK:アコーディオン処理（求人情報）
   ------------------------------------ */

  /**
   * アコーディオンを閉じるときのキーフレーム
   */
  const closingAnimKeyframes_job = (content, height) => [
    {
      height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
      // opacity: 1,
    }, {
      height: height,
      // opacity: 0,
    }
  ];

  /**
   * アコーディオンを開くときのキーフレーム
   */
  const openingAnimKeyframes_job = (content, height) => [
    {
      height: height,
      // opacity: 0,
    }, {
      height: content.scrollHeight + 'px',
      // opacity: 1,
    }
  ];

  const $recruitMoreTrigger = document.querySelectorAll('[data-jobtrigger]');

  if ($recruitMoreTrigger.length) {

    $recruitMoreTrigger.forEach((trigger) => {

      let $jobTgt = document.querySelector('#' + trigger.getAttribute('aria-controls'));
      let content = $jobTgt.querySelector('.job__detail--body');
      let closeHeight;

      // 3行分の高さを計算する関数
      const getBodyHeight = (element) => {
        const $style = window.getComputedStyle(element);
        const $lineHeight = parseFloat($style.lineHeight);
        const $paddingTop = parseFloat($style.paddingTop);
        const $paddingBottom = parseFloat($style.paddingBottom);

        // line-heightがnormalの場合は、font-sizeから計算
        const $actualLineHeight = isNaN($lineHeight)
          ? parseFloat($style.fontSize) * 1.8
          : $lineHeight;

        return ($actualLineHeight * 3) + $paddingTop + $paddingBottom;
      };

      // 初期高さを設定（実際の高さと比較しての小さい方を設定）
      const setHeight = (content) => {
        const $threeLineHeight = getBodyHeight(content);
        const $actualHeight = content.scrollHeight;
        closeHeight = Math.min($threeLineHeight, $actualHeight) + 'px';

        // 初期状態で閉じた高さを設定
        if (!$jobTgt.classList.contains('is-open')) {
          content.style.height = closeHeight;
          // content.style.overflow = 'hidden';
        }
      }

      // 初期実行
      setHeight(content);

      // レスポンシブ対応: ブレイクポイント変更時に高さを再計算
      const handleResize = () => {
        // autoにして正確な高さを取得
        if (!$jobTgt.classList.contains('is-open')) {
          content.style.height = 'auto';
        }
        setHeight(content);
      };
      mediaQuery.addEventListener('change', handleResize);

      trigger.addEventListener('click', (element) => {
        element.preventDefault();

        let $getLabel = trigger.querySelector('.is-label');

        // 連打防止
        if (trigger.dataset.animStatus === isRunning) {
          return;
        }

        if ($jobTgt.classList.contains('is-open')) {
          // アコーディオンを閉じるときの処理

          // 最新の高さを再計算
          const $threeLineHeight = getBodyHeight(content);
          const $actualHeight = content.scrollHeight;
          closeHeight = Math.min($threeLineHeight, $actualHeight) + 'px';

          // アニメーションを実行
          const closingAnim = content.animate(closingAnimKeyframes_job(content, closeHeight), animTiming);
          $jobTgt.dataset.animStatus = isRunning;

          setTimeout(function () {
            $jobTgt.classList.remove('is-open');
            content.style.height = closeHeight;
            $getLabel.textContent = '詳細を表示';
          }, 50);

          closingAnim.onfinish = () => {
            $jobTgt.dataset.animStatus = '';
          };

        } else {
          // アコーディオンを開くときの処理
          $jobTgt.classList.add('is-open');
          $getLabel.textContent = '閉じる';

          const openingAnim = content.animate(openingAnimKeyframes_job(content, closeHeight), animTiming);
          $jobTgt.dataset.animStatus = isRunning;

          openingAnim.onfinish = () => {
            content.style.height = 'auto';
            $jobTgt.dataset.animStatus = '';
          };
        }
      });
    });

  }




  /*
   * MARK:もっと見るボタン
   ------------------------------------ */
  const $morelistTrigger = document.querySelector('[data-morelist]');

  if ($morelistTrigger) {

    // 初期情報取得
    const $firstView = $morelistTrigger.dataset.morelist;
    const $showItem = $morelistTrigger.dataset.morelist;

    const $tgtList = document.querySelector('#' + $morelistTrigger.getAttribute('aria-controls'));
    const $tgtItem = $tgtList.children;

    // 一度すべて非表示
    for (let i = 0; i < $tgtItem.length; i++) {
      $tgtItem[i].setAttribute('aria-hidden', 'true');
    }

    // アイテム数により表示数を調整
    if ($firstView < $tgtItem.length) {

      // 「$firstView」の件数だけ表示する
      for (let i = 0; i < $firstView; i++) {
        $tgtItem[i].setAttribute('aria-hidden', 'false');
      }

      // ボタン表示
      $morelistTrigger.setAttribute('aria-hidden', 'false');

    } else {

      // 「$firstView」の件数よりアイテム数が少ない場合は全件表示する
      for (let i = 0; i < $tgtItem.length; i++) {
        $tgtItem[i].setAttribute('aria-hidden', 'false');
      }

      // ボタンは隠す
      $morelistTrigger.setAttribute('aria-hidden', 'true');

    }

    // もっと見るボタンの処理
    $morelistTrigger.addEventListener('click', funcMoreView);

    function funcMoreView(e) {

      // 非表示のアイテム数を取得
      let $hideList = document.querySelectorAll('#' + $morelistTrigger.getAttribute('aria-controls') + ' li[aria-hidden="true"]');

      let $addView = $showItem;
      let $cnt = 0;

      // aria-hidden=trueの数を数える
      for (let i = 0; i < $hideList.length; i++) {
        $cnt++;
      }

      if ($addView > $cnt) {
        $addView = $cnt;
      }

      for (let i = 0; i < $addView; i++) {
        $hideList[i].setAttribute('aria-hidden', 'false');
      }

      // [aria-hidden="true"]を再取得して0の場合はボタンを非表示にする
      $hideList = document.querySelectorAll('#' + $morelistTrigger.getAttribute('aria-controls') + ' li[aria-hidden="true"]');
      if ($hideList.length == 0) {
        $morelistTrigger.setAttribute('aria-hidden', 'true');
      }
    };

  }



  /*
   * MARK:パララックス
   ------------------------------------ */
  // 実行対象の要素を取得
  const $scrollElement = document.querySelector('.main__body');
  let moveFlag = false;

  // background-imageが設定されているかチェック
  if ($scrollElement) {
    const computedStyle = window.getComputedStyle($scrollElement);
    const backgroundImage = computedStyle.getPropertyValue('background-image');

    // background-imageが存在し、noneではない場合に実行フラグを立てる
    if (backgroundImage && backgroundImage !== 'none') {
      moveFlag = true;
    }
  }

  // 背景画像があるとき、イベントを設定
  if (moveFlag) {
    // スクロール位置を保存
    let saveScrollY = window.scrollY;

    // スクロールイベントリスナーを設定
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;

      // 既に設定されているCSS変数値を取得
      const currentOffsetStyle = getComputedStyle(document.documentElement).getPropertyValue('--bgdeco-offset');

      // スクロール量の差分（方向と量をcheck）
      const scrollDelta = currentScrollY - saveScrollY;
      const offsetChange = -scrollDelta;

      // 数値に変換
      const currentOffsetValue = parseFloat(currentOffsetStyle);

      // 新しいCSS変数の値をセット
      const newOffsetValue = (currentOffsetValue / 2) + offsetChange;
      document.documentElement.style.setProperty('--bgdeco-offset', `${newOffsetValue}px`);

      // 次のスクロールイベントのために現在の位置を保存
      saveScrollY = currentScrollY;
    });

  }



  /*
   * MARK:Modal（プラグイン使用）
     https://micromodal.vercel.app/
   ------------------------------------ */

  // 変数設定
  // const $modalTrigger = document.querySelectorAll('[data-modaltrigger]');
  // const $modalClose = document.querySelectorAll('[data-micromodal-close]');

  // 初期設定
  MicroModal.init({
    onShow: modal => {
      $html.classList.add('is-modal');
    },
    onClose: modal => {
      $html.classList.remove('is-modal');
    },
    openTrigger: 'data-modaltrigger',
    closeTrigger: 'data-micromodal-close',
    disableScroll: false,
    disableFocus: false,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
  });


});
